"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    autocompleteListItemVariants: ()=>autocompleteListItemVariants
});
const external_tailwind_variants_namespaceObject = require("tailwind-variants");
const autocompleteListItemVariants = (0, external_tailwind_variants_namespaceObject.tv)({
    slots: {
        itemWrapperSlot: 'bg-neutral-1 flex h-16 justify-between gap-2 rounded-lg border-2 border-transparent p-2',
        leftNodeAndTextSlot: 'flex gap-2',
        leftNodeIconWrapperSlot: 'my-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-lg',
        textSlot: 'my-auto flex flex-col px-1',
        rightNodeSlot: 'my-auto',
        groupHeaderWrapper: 'h-8 pb-1 pl-3 pt-2'
    },
    variants: {
        isHighlighted: {
            true: {
                itemWrapperSlot: 'bg-primary-2'
            }
        },
        isSelected: {
            true: {
                itemWrapperSlot: 'bg-primary-3'
            }
        },
        isIndented: {
            true: {
                leftNodeAndTextSlot: 'pl-6'
            }
        },
        isHighlightedIndexWithKeyArrow: {
            true: {
                itemWrapperSlot: 'border-primary-8 border-2'
            }
        }
    },
    compoundVariants: [
        {
            isSelected: true,
            isHighlighted: true,
            class: {
                itemWrapperSlot: 'bg-primary-4'
            }
        }
    ],
    defaultVariants: {
        isHighlighted: false,
        isSelectedItem: false
    }
});
exports.autocompleteListItemVariants = __webpack_exports__.autocompleteListItemVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "autocompleteListItemVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
